import styled, { css } from "styled-components";
import { Modal } from "components/Modal";

// Shared shell for the small centered confirm dialogs
// (PlanConfirmation / Downgrade / Reactivate). Matches the Figma design;
// only truly modal-specific pieces stay in each modal.
export const ConfirmDialogContainer = styled(Modal)`
  z-index: 1060;

  &.modal {
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-dialog {
    max-width: 440px;
  }

  .modal-content {
    padding: 28px 28px 24px;
    border-radius: 16px;
    font-family: "Geist", sans-serif;
  }

  .modal-body {
    padding: 0;
    margin: 0;
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;
    }

    .modal-content {
      padding: 20px;
    }
  }
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  color: #181d27;
  margin: 0 0 10px;
  font-family: "Geist", sans-serif;
  letter-spacing: -0.2px;
`;

export const Body = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #535862;
  line-height: 1.6;
  letter-spacing: -0.1px;
  margin: 0 0 18px;
  font-family: "Geist", sans-serif;
`;

export const BillingBox = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: #fafafa;

  .billing-left {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .billing-plan {
    font-size: 14px;
    font-weight: 500;
    color: #181d27;
    font-family: "Geist", sans-serif;
  }

  .billing-date {
    font-size: 12px;
    color: #717680;
    font-family: "Geist", sans-serif;
  }

  .billing-price {
    font-size: 14px;
    font-weight: 500;
    color: #181d27;
    font-family: "Geist", sans-serif;
    white-space: nowrap;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 480px) {
    flex-direction: column-reverse;
  }
`;

// --- Buttons (Figma-matching compact style, shared across the 3 dialogs) ---

const baseButton = css`
  flex: 1;
  min-height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  font-family: "Geist", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.15s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// Loader shown beside the label while submitting (single definition, was
// duplicated in three files before).
const btnLoader = css`
  .btn-loader {
    width: 16px !important;
    height: 16px !important;

    .loader {
      color: #fff;

      .spinner-border {
        width: 16px;
        height: 16px;
        border-width: 2px;
      }
    }
  }
`;

export const PrimaryButton = styled.button`
  ${baseButton}
  background: #181d27;
  color: #fff;
  border: none;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #2d3748;
  }

  ${btnLoader}
`;

export const DangerButton = styled.button`
  ${baseButton}
  background: #b6544c;
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.12);

  &:hover:not(:disabled) {
    background: #a2453d;
  }

  ${btnLoader}
`;

export const SecondaryButton = styled.button`
  ${baseButton}
  background: #fff;
  color: #374151;
  border: 1px solid #d5d7da;

  &:hover:not(:disabled) {
    background: #f9fafb;
  }
`;
